import { render } from "./AppConfirm.vue?vue&type=template&id=febca58c"
import script from "./AppConfirm.vue?vue&type=script&lang=js"
export * from "./AppConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__